import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

import "./styles/workExperience.css";

const WorkExperience = () => {
	const workExperiences = [
		{
			company: "Robinhood",
			position: "Software Engineer",
			duration: "Aug 2025 - Present",
			location: "Toronto, Canada",
			logo: "./robinhood.png",
			description: "Working on building scalable financial technology solutions and improving trading platform infrastructure.",
			technologies: ["Financial Technology", "Brokerage Platform", "Scalable Systems", "Internationalization"]
		},
		{
			company: "Cresta",
			position: "Software Engineer",
			duration: "Jun 2024 - Aug 2025",
			location: "Toronto, Canada",
			logo: "./cresta.png",
			description: "Designed and launched integration services for multiple CCaaS platforms—including Amazon Connect, NICE CXone, Genesys, and TCN—enhancing backend interoperability and enabling seamless communication between Cresta's backend platform and customer systems. Implemented integration with Cresta's AI Agent to enable real-time, bidirectional audio streaming for AI-powered voice interactions.",
			technologies: ["Integration Services", "CCaaS Platforms", "AI Agent", "Real-time Audio"]
		},
		{
			company: "Huawei",
			position: "Software Engineer",
			duration: "Feb 2023 - Jun 2024",
			location: "Toronto, Canada",
			logo: "./huawei.png",
			description: "Implemented a just-in-time compiler tool to optimize SQL queries using LLVM intermediate representation. Optimized the sort operator by adding new methods (insertion sort, radix sort and counting sort) and using adaptive algorithms, increasing overall performance by 2.5% on TPC-DS benchmark.",
			technologies: ["LLVM", "SQL Optimization", "Jenkins", "Big Data", "Compiler"]
		},
		{
			company: "Talka",
			position: "Machine Learning Engineer",
			duration: "May 2022 - Dec 2022",
			location: "Toronto, Canada",
			logo: "./talka.png",
			description: "Built models to help product managers know their users better and get feedback more efficiently. Predicted deal success rate with neural networks based on text, audio, and video data. Implemented question classification model for text data with a BERT model.",
			technologies: ["Machine Learning", "BERT", "Multi-modal Data Analysis"]
		},
		{
			company: "Meituan",
			position: "Software Engineer",
			duration: "Feb 2021 - Jun 2021",
			location: "Beijing, China",
			logo: "./meituan.png",
			description: "Implemented the routing search algorithm of unmanned delivery vehicle. Designed simulation test samples with high-precision map data. Analyzed real driving data and maintained the interface between high-precision map and the planning&control module.",
			technologies: ["Routing Algorithms", "High-precision Maps", "Autonomous Vehicles"]
		}
	];

	return (
		<div className="work-experience-container">
			{workExperiences.map((experience, index) => (
				<div className="work-experience-item" key={index}>
					<div className="work-experience-header">
						<div className="work-experience-logo">
							<img src={experience.logo} alt={`${experience.company} logo`} />
						</div>
						<div className="work-experience-details">
							<h3 className="work-experience-company">{experience.company}</h3>
							<h4 className="work-experience-position">{experience.position}</h4>
							<div className="work-experience-meta">
								<div className="work-experience-duration">
									<FontAwesomeIcon icon={faCalendar} />
									<span>{experience.duration}</span>
								</div>
								<div className="work-experience-location">
									<FontAwesomeIcon icon={faMapMarkerAlt} />
									<span>{experience.location}</span>
								</div>
							</div>
						</div>
					</div>
					<div className="work-experience-content">
						<p className="work-experience-description">{experience.description}</p>
						<div className="work-experience-technologies">
							{experience.technologies.map((tech, techIndex) => (
								<span key={techIndex} className="technology-tag">{tech}</span>
							))}
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default WorkExperience;